<template>
  <div class="app-container">
    <div class="filter-container">
      <hl-select class="filter-item" :selectedList="HeaderTime" placeholder="请选择时间" @selectList = "selectTime" />
      <span class="filter-item">-</span>
      <div class="filter-item">
        <div v-if="HeaderID.length > 35">
          <el-cascader :options="options" :props="props" 
            collapse-tags size="small" filterable
            placeholder="输入关键词查找"
            @change="caseSelect"
            style="width: 250px;"
            v-model="caselist"
            clearable
            :show-all-levels="false"
          />
        </div>
        <div v-else>
          <hl-select :selectedList="HeaderID" placeholder="请选择区域" @selectList = "selectID" />
        </div>
      </div>
      
      <span class="filter-item">-</span>
      <el-button class="filter-item" type="danger" icon="el-icon-coin" size="small" @click="imBuy">立即购买</el-button>
      <el-button class="filter-item" @click="addToCart" type="warning" icon="el-icon-shopping-cart-2" size="small">添加到购物车</el-button>
    </div>
  </div>
</template>
<script>
import HlSelect from '@/components/HlSelect';
import { mapActions, mapMutations, mapState } from 'vuex';
import { addCart, deleteCart } from '@/api/cart';
import store from '@/store'
import { citylabel, countylabel } from '@/tableworks/admin'

export default {
  components:{ HlSelect },
  data(){
    return{
      checked: false,
      listQuery:{
        iid_list: [],
        time_list: [],
      },
      caselist: [],
      props:{
        multiple: true, 
        expandTrigger: 'hover', 
        emitPath: false,
      },
      selectStates: 0,
      iids: null,
      times: null,
      prices: null,
    }
  },

  computed:{
    ...mapState('listdata', ['clicknode']),
    ...mapState('cart', ['cartProducts']),
    options(){
      this.caselist = []
      if (this.HeaderID.length > 364) {
        return countylabel(this.HeaderID)
      } else if (this.HeaderID.length < 365 && this.HeaderID.length > 35) {
        return citylabel(this.HeaderID)
      } else {
        return false
      }
    },
  }, 
  props:{
    HeaderTime: {
      type: Array,
      required: true
    },
    HeaderID: {
      type: Array,
      required: true
    },
  },
  watch:{
    caselist(val) {
      if(val[0] === "全选") {
        this.listQuery.iid_list = ["全选"]
        this.iids = val.length - 1
      } else {
        this.listQuery.iid_list = val
        this.iids = val.length
      }
    },
    HeaderID(val) {
      this.iids = null
      this.times = null
    }
  },

  methods:{
    ...mapMutations('orderlist',['addToOrderlist']),
    ...mapActions('cart',['getFromCart','addToOrder']),
    selectTime(e) {
      if (e[0] === "全选") {
        this.listQuery.time_list = ["全选"]
        this.times = e.length - 1
      } else {
        this.listQuery.time_list = e
        this.times = e.length
      }
    },
    selectID(e) {
      if(e[0] === "全选") {
        this.listQuery.iid_list = ["全选"]
        this.iids = e.length - 1
      } else {
        this.listQuery.iid_list = e
        this.iids = e.length
      }
    },
    caseSelect(val) {
      if ((val.includes('全选') || (!val.includes('全选') && (val.length === this.HeaderID.length))) && this.selectStates === 0) {
        this.caselist = this.selectAll()
        this.selectStates = 1
        return false
      }
      if (val.includes('全选') && (val.length - 1) < this.HeaderID.length) {
        this.caselist = this.caselist.filter(item => {
          return item !== '全选'
        })
        this.selectStates = 0
        return false
      }
      if (this.selectStates == 1) {
        this.caselist = [];
        this.selectStates = 0;
        return false
      } else {
        this.caselist = val
      }
    },
    selectAll() {
      let selectAllData = [...this.HeaderID]
      selectAllData.unshift('全选')
      return selectAllData
    },
    async imBuy() {
      if (store.getters.token) {
        const iids = this.iids
        const times = this.times
        this.prices = Number((iids * times * this.clicknode.price).toFixed(2))

        if (iids && times) {
          const buyid = [Object.assign(this.clicknode,{ iids, times},this.listQuery,{'count':1},{'prices':this.prices})]
          const prods = this.cartProducts.filter(item => item.newpid === this.clicknode.newpid)
          if (prods.length > 0) {
            deleteCart(this.clicknode.newpid)
            this.getFromCart()
          }
          await this.addToOrder(buyid).then(
            () => {
              this.$router.push({path:'/order-detail', replace: true})
            }
          )
        } else {
          this.$message({
            message: '请选择要购买的数据！',
            type: 'warning'
          })
        }
      } else {
        this.$message({
          message: '请登录红兰数据库！',
          type: 'error'
        })
      }
    },
    async addToCart() {
      if (store.getters.token) {
        const iids = this.iids
        const times = this.times
        if (iids && times) {
          Object.assign(this.clicknode, { iids, times }, this.listQuery)
          await addCart(this.clicknode)
          this.getFromCart()
          this.$message.success('购物车添加成功！')
        } else {
          this.$message({
            message: '请选择要购买的数据！',
            type: 'warning'
          })
        }
      } else {
        this.$message({
          message: '请登录红兰数据库！',
          type: 'error'
        })
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.app-container {
  padding: 0 0 5px 0;
  position: relative;
  .filter-container {
    .filter-item {
      display: inline-block;
      vertical-align: middle;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/layout/components/FilterHead/index.vue